<div class="col-12" style="background-color: #FFFFFF;">
  <!-- <app-navbar class="sticky-top"></app-navbar> -->
  <router-outlet></router-outlet>
  <!-- <app-footer></app-footer> -->
</div>